export default __webpack_public_path__ + "static/media/plain-sticker-m.3e67ab28.png";